import React, { Component } from 'react';
import { Grid, Label, Divider } from 'semantic-ui-react'
import Select from 'react-select';


class SiniyaDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            siniyaSchoolHouses:'',
            siniyaSchoolHouseChoices: [
                { value: 'Bikangaga', label: 'Bikangaga', category: 'jerseyName' },
                { value: 'Bwankosya', label: 'Bwankosya', category: 'jerseyName' },
                { value: 'Lumumba', label: 'Lumumba', category: 'jerseyName' },
                { value: 'Makobore', label: 'Makobore', category: 'jerseyName' },
            ],
         }
    }
    render() { 
        return ( 
            <Grid.Column >
                {/* SHIRT TYPE */}
                <Label pointing='below' color='blue'>{'SELECT YOUR HOUSE NAME'}</Label>
                <Select
                    name="form-field-name"
                    value={this.props.jerseyName}
                    options={this.state.siniyaSchoolHouseChoices}
                    onChange={this.props.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </Grid.Column>
         )
    }
}
 
export default SiniyaDropDown;


// WEBPACK FOOTER //
// ./src/components/newSite/Siniya/SiniyaDropdown.js